/** Đường dẫn Backend thật, đối chiếu runtime OpenAPI. Các API không có không được gọi. */
const id = (value: string) => encodeURIComponent(value);
export const endpoints = {
  auth: { login: '/auth/login', refresh: '/auth/refresh', logout: '/auth/logout', me: '/api/v2/me' },
  serviceAreas: '/api/v2/service-areas',
  places: { search: '/api/v2/map/places' },
  quotes: { create: '/api/v2/trip-quotes' },
  trips: {
    create: '/api/v2/trips', list: '/api/v2/trips',
    detail: (value: string) => `/api/v2/trips/${id(value)}`,
    transitions: (value: string) => `/api/v2/trips/${id(value)}/transitions`,
    timeline: (value: string) => `/api/v2/trips/${id(value)}/timeline`,
  },
  commands: { detail: (value: string) => `/api/v2/commands/${id(value)}` },
  routeOptions: { detail: (value: string) => `/api/v2/route-options/${id(value)}` },
  proposals: {
    detail: (value: string) => `/api/v2/proposals/${id(value)}`,
    consents: (value: string) => `/api/v2/proposals/${id(value)}/consents`,
    revokeConsent: (value: string) => `/api/v2/consents/${id(value)}/revoke`,
  },
  support: {
    sos: '/api/v2/safety/sos', requests: '/api/v2/support/cases',
    detail: (value: string) => `/api/v2/support/cases/${id(value)}`,
    events: (value: string) => `/api/v2/support/cases/${id(value)}/events`,
  },
  notifications: { list: '/api/v2/notifications', seen: (value: string) => `/api/v2/notifications/${id(value)}/seen` },
  events: '/api/v2/events',
} as const;
